<template>
  <b-overlay :show="isLoading">
    <SelectComponent
        :options="companies"
        :disabled="disabled"
        :searching="isLoading"
        @search="autocomplete"
        @input="evt => $emit('input', evt)">
    </SelectComponent>
  </b-overlay>
</template>

<script>
import SelectComponent from "@/components/SelectComponent";
import {mapActions, mapGetters} from "vuex";

export default {
  name: "SelectCompanies",
  components: {SelectComponent},
  props: {
    model: null,
    disabled: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    ...mapGetters({
      isLoading: 'corecompanies/isLoading',
      store_companies: 'corecompanies/all',
    }),
    companies() {
      if (this.store_companies && Array.isArray(this.store_companies)) {
        return this.store_companies.map(ent => {
          return {
            label: ent.name,
            value: ent.id
          }
        })
      }
      return []
    },
  },
  data() {
    return {
      stringSearch: ''
    }
  },
  methods: {
    ...mapActions([
      'corecompanies/listAll',
      'corecompanies/search',
    ]),
    async autocomplete(string) {
      this.stringSearch = string
      if (string.length >= 3) {
        // TODO: REMOVER E PASSAR CASE SENSITIVE PARA P BANCO
        this.temporallyStringPrepareToSQL('name', string).map(async array => {
          await this['corecompanies/search']({filters: [array]})
        })
      }
    },
    // TODO: REMOVER E PASSAR CASE SENSITIVE PARA P BANCO
    temporallyStringPrepareToSQL(field, valueTyped) {
      const string = valueTyped.toLowerCase()
      return [
        [field, 'LIKE', '%' + valueTyped + '%'],
        [field, 'LIKE', '%' + string + '%'],
        [field, 'LIKE', '%' + string.toUpperCase() + '%'],
        [field, 'LIKE', '%' + string.charAt(0).toUpperCase() + string.slice(1) + '%'],
      ]
    }
  },
  mounted() {
    this['corecompanies/listAll']()
  }
}
</script>

<style lang="scss" scoped>
</style>